import { render } from "./Footer.vue?vue&type=template&id=ed346f36&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=ed346f36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed346f36"]])

export default __exports__